//#region Imports and Global Definitions
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet, Animated, View, SafeAreaView, Platform, useWindowDimensions, Pressable, FlatList, TouchableOpacity } from 'react-native';
import { ActivityIndicator, Card } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../../styles/commonStyles';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../../components/CustomInput';
import CustomButton from '../../../../components/CustomButton';
import CustomCalendar from '../../../../components/CustomCalendar/CustomCalendar';
import CustomDropDown from '../../../../components/CustomDropDown/CustomDropdown';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { useCompany } from '../../../../hooks/useCompany';
import { useTableHelper } from '../../../../hooks/useTableHelper';
import { changeDateFromDDMMYYYYtoYYYYMMDD, changeDateFromYYYYMMDDToDDMMYYYY } from '../../../../constants/FormatDate';
import HRAdminSalaryComponentsScreen from './HRAdminSalaryComponentsScreen';
var _ = require('lodash');
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
//#endregion

//* Using React.memo outside the component definition is the correct approach to memoize a component in React.
//* It ensures that the component is memoized only once and reused across renders, improving performance and maintaining code clarity. 
//* This is particularly important when rendering lists with FlatList in React Native, where performance optimization is crucial.
const SalarySchemeListView = React.memo(({ item, index, props, styles, handleEditPress, duplicates, handleDelete, handlePress, showChildren, colors }) => {
    //#region Calendar & Show Hidden
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [rangeText, setRangeText] = useState('')

    let errorMark = false;
    let errorAttr = '';

    // * On line load set the calendar to the selected dates if existent
    useEffect(() => {
        let to = '';
        let from = '';
        if (item?.fdate !== '' && item?.fdate !== null)
            from = changeDateFromDDMMYYYYtoYYYYMMDD(item?.fdate)
        if (item?.tdate !== '' && item?.tdate !== null)
            to = changeDateFromDDMMYYYYtoYYYYMMDD(item?.tdate)

        //* Different structure of the data based on what dates are set 
        if (to !== '' && from !== '') {
            setRangeText(item?.fdate + ' - ' + item?.tdate)
            setSelectedData({ startDate: from, endDate: to })
        }
        else if (to === '' && from !== '') {
            setRangeText(item?.fdate + ' - ')
            setSelectedData({ startDate: from })
        }
        if (to === '' && from === '') {
            setRangeText('')
            setSelectedData([])
        }

        //* Set Range Text for Custom Label 

    }, [])

    // * convert to DDMMYYY view for the user 
    // ! This runs 1 extra time on load set for calendar but should be ok, no major perfomance problems are observed. 
    useEffect(() => {
        if (Object.keys(selectedData).length > 0) {
            let dateArr = dateHelper();
            handleEditPress(index, item, 'fdate - tdate', dateArr)
            setRangeText(dateArr[0] + ' - ' + dateArr[1])
        }
    }, [selectedData])

    const dateHelper = () => {
        let dateArr = []
        let tmpTdate = '';
        let tmpFdate = '';
        if (selectedData?.startDate !== '' && selectedData?.startDate !== undefined)
            tmpFdate = changeDateFromYYYYMMDDToDDMMYYYY(selectedData?.startDate);
        if (selectedData?.endDate !== undefined && selectedData?.endDate !== '') {
            tmpTdate = changeDateFromYYYYMMDDToDDMMYYYY(selectedData?.endDate);
        }
        dateArr.push(tmpFdate)
        dateArr.push(tmpTdate)

        return dateArr;
    }

    // * handleEditPress sets state so calling it twice from the same function will not update resulting on wrong dates
    // * As a result, send both tdate and fdate in the same call and handle the separation in the listener itself 
    const onShowCalendarPress = () => {

        let dateArr = []
        if (showCalendar) {
            let dateArr = dateHelper();
            handleEditPress(index, item, 'fdate - tdate', dateArr)
        }
        setShowCalendar(!showCalendar)
    }

    duplicates.forEach(duplicate => {
        if (duplicate.attrVal.includes(item[duplicate.attribute])) {
            errorMark = true;
            errorAttr = duplicate.attribute;
        }
    });
    //#endregion

    return (
        <SafeAreaView>
            <SafeAreaView>
                {showChildren ?
                    <SafeAreaView
                        style={[{ alignContent: 'center' }]}>
                        <CustomLabel
                            value={item?.desc === "" ? item?.salarySchemeId : item?.desc}
                            type="BRANCHES_WHEN_SHOWING_LOCATIONS" />

                    </SafeAreaView>
                    :
                    // * Main View
                    <SafeAreaView>
                        <SafeAreaView style={styles.row}>
                            <Animated.View
                                style={[styles.item, { justifyContent: 'flex-start' }]}>
                                <CustomInput
                                    // defaultValue={item?.desc}
                                    value={item?.desc}
                                    setValue={(e) => handleEditPress(index, item, 'desc', e)}
                                    maxLen={255}
                                    //hasNotProvidedCode[item?.index] || isDuplicate[item?.index]
                                    type={errorMark && errorAttr == 'desc' ? "MISSING_BRANCHES_CODE" : "MAININPUT"}
                                    editable={props.showSalaryScheme ? false : true}
                                />
                            </Animated.View>
                            <Animated.View
                                style={[styles.item]}>
                                <SafeAreaView style={styles.row}>
                                    <CustomInput
                                        defaultValue={rangeText}
                                        value={rangeText}
                                        maxLen={50}
                                        type={errorMark && errorAttr == 'fdate' ? "MISSING_BRANCHES_CODE" : "MAININPUT"}
                                        editable={false}
                                    />
                                    <Ionicons
                                        name={showCalendar ? "calendar" : "calendar-outline"}
                                        style={styles.icons}
                                        onPress={() => onShowCalendarPress(true)}
                                    />
                                    <Ionicons
                                        name={showCalendar ? "chevron-down-outline" : "chevron-back-outline"}
                                        style={styles.icons}
                                        onPress={() => onShowCalendarPress(true)}
                                    />
                                </SafeAreaView>
                            </Animated.View>
                            <Animated.View
                                style={[styles.item]}>
                                <CustomDropDown
                                    defValue={item?.currency}
                                    options={props.currencies}
                                    value={item?.currency}
                                    setValue={(e) => handleEditPress(index, item, 'currency', e)}
                                    type="NEW_COMPANY"
                                />
                            </Animated.View>
                            <SafeAreaView style={styles.margin}>
                                {item?.childCount <= 0 &&
                                    <CustomButton
                                        iconName='trash-outline'
                                        onPress={() => {
                                            handleDelete(item, index, 'salarySchemeId')
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={30} />
                                }
                                {item.salarySchemeId !== '' &&
                                    <CustomButton
                                        iconName='wallet-outline'
                                        onPress={() => {
                                            handlePress(item, index)
                                        }}
                                        show='HOME_BELL'
                                        type='HOME_BELL'
                                        textTop='2'
                                        sz={30} />
                                }
                            </SafeAreaView>
                        </SafeAreaView>
                        {showCalendar &&
                            <SafeAreaView style={styles.secondLine}>
                                {/* calendar view */}
                                <View style={{
                                    height: Platform.OS === 'web' ? 285 : (height < 670 ? height * 40 / 100 : height * 30 / 100),
                                    width: Platform.OS === 'web' ? 485 : width * 90 / 100,
                                    justifyContent: 'center',
                                    alignItems: "center",
                                    borderRadius: 10,
                                    borderWidth: 0,
                                    borderColor: colors.border_card,
                                }}>
                                    <CustomCalendar
                                        calendarType={'RangePicker'}
                                        setRange={setSelectedData}
                                        range={selectedData}
                                    />
                                </View>
                            </SafeAreaView>
                        }
                    </SafeAreaView>
                }
            </SafeAreaView>
        </SafeAreaView>
    )
})

const HRAdminSalarySchemeScreen = (props) => {
    //#region Const Definitions
    const { colors } = useTheme();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const styles = makeStyles(colors, width, height, isPlatformWeb);
    const common = createCommonStyles(colors);
    const { width, height } = useWindowDimensions();
    const { getSalarySchemes, saveSalarySchemes, deleteSalaryScheme, isLoading } = useCompany();
    const { hasDuplicates, handleCancelChanges, areAllAttributesNullOrEmpty, rowAdd, rowDelete, rowEdit } = useTableHelper();
    const [salarySchemeData, setSalarySchemeData] = useState([]);
    const [changes, setChanges] = useState([]);
    const [changesChildren, setChangesChildren] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [showChildren, setShowChildren] = useState(false);
    const [deletedItems, setDeletedItems] = useState([])
    const [selectedItem, setSelectedItem] = useState(null);
    const [buttonStates, setButtonStates] = useState({});
    const [duplicates, setDuplicates] = useState([])
    const [refreshAfterSave, setRefreshAfterSave] = useState(false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const companyRef = useRef(null);
    const ref = useRef(null);
    const { t } = useTranslation();
    //#endregion

    //#region UseEffect
    useEffect(() => {
        if (!refreshAfterSave && companyRef.current === props.selectedCompany) return;
        companyRef.current = props.selectedCompany;
        getSalarySchemes(props.selectedCompany)
            .then((resp) => {
                setSalarySchemeData(resp)
                setOriginalData(resp)
            })
            .catch(() => {
                setRefreshAfterSave(false);
            })
    }, [props.selectedCompany, refreshAfterSave])

    useEffect(() => { setShowChildren(props.showSalaryScheme) }, [props.showSalaryScheme])
    //#endregion

    //#region Listeners
    // * Edit labels
    const handleEditPress = useCallback((idx, item, key, value) => {
        rowEdit(idx, item, key, value, changes, setChanges, salarySchemeData, setSalarySchemeData)
    }, [])

    //#region New/Save/Cancel
    //* Save
    const handleSave = async () => {
        let newPromises = [];
        let deleteSucc = false;
        let updateSucc = false;
        let valid = true;

        // * Do not save if Changes table is empty
        if (Object.entries(changes).length == 0 && deletedItems.length == 0) {
            showMessage({
                message: t('common:noChanges'),
                type: "danger",
                duration: 3000,
            })
            return
        }

        // * Check that there is only 1 entry without tdate which indicates the most recent Salary Scheme 
        // * Also check that the date is later than all the other from dates. 
        // ! We do not currently need to check if tdate < fdate because the calendar does not allow you to mkae that selection :)
        let valRet = validateInput();
        if (!valRet[0]) {
            showMessage({
                message: valRet[1],
                type: "danger",
                duration: 3000,
            })
        }

        //* Attribute definition of values that can be the same in salary schemes 
        const attributesToIgnore = ["company", "currency", "childCount"];
        // * Check for duplicates,
        // * The loop from the one row is to avoid typing all the object attributes. 

        if (salarySchemeData.length > 0)
            Object.keys(salarySchemeData[0]).forEach(key => {
                //* Ignore Keys that we know can be duplicated 
                if (!attributesToIgnore.includes(key)) {
                    if (hasDuplicates(salarySchemeData, key, setDuplicates)) {
                        console.log('duplicates', key)
                        showMessage({
                            message: t('common:duplicates'),
                            type: "danger",
                            duration: 3000,
                        })
                        // * Abort Save if this is triggered.
                        valid = false;
                    }
                }
            });

        if (!valid)
            return null;

        // TODO Check for dates descending  - TBH I do not see the reason of doing this currently. 
        // console.log(checkDatesDescending())

        //#region Create Promise
        if (Object.entries(changes).length > 0) {
            newPromises.push(
                saveSalarySchemes(changes)
                    .then((res) => {
                        if (res) {
                            updateSucc = res;
                            removeFromChangesAfterSave();
                        }

                    })
                    .catch(() => { }))
        }

        if (deletedItems.length > 0) {
            newPromises.push(deleteSalaryScheme(deletedItems)
                .then((res) => {
                    if (res) {
                        deleteSucc = true
                        removeFromChangesAfterSave();
                    }
                }).catch(() => { }))
        }

        //#endregion

        // * Send the Changes table in the API which only includes Updated or new Lines
        // * No check in the API if row changed. 
        try {
            await Promise.all(newPromises).then(() => {
                if (!updateSucc) {
                    if (!deleteSucc) {
                        showMessage({
                            message: t('common:deleteFailed'),
                            type: "danger",
                            duration: 3000,
                        })
                    }
                    else
                        showMessage({
                            message: t('common:issueMessage'),
                            type: "error",
                            duration: 3000,
                        })

                }
                else if (deleteSucc || updateSucc) {
                    showMessage({
                        message: t('common:allOperationsSuccMess'),
                        type: "success",
                        duration: 3000,
                    })
                    setRefreshAfterSave(true);
                }
            });
        } catch (error) {
            console.log(error)
            setRefreshAfterSave(true);
        }
    }

    const handleDelete = (item, index, attribute) => {
        rowDelete(item, index, attribute, changes, setChanges, salarySchemeData, setSalarySchemeData, setDeletedItems, ref)
    }

    //#endregion

    // * Validator 
    // TODO Can be abstracted as well probably -- But column names matter ? 
    const validateInput = () => {
        let primarytDate = new Set();
        let ret = [true, t('common:validationSuccess')]
        salarySchemeData.forEach((itr) => {
            // * Set primary Scheme Date
            if (itr.tdate === '') {
                // * if Primary Date is not empty string then multiple primary => ERROR
                if (primarytDate.has(itr.fdate)) {
                    ret = [false, t('common:onePrimary')];
                }
                primarytDate.add(itr.fdate)
            }
            // * Check empty description
            if (itr.desc === '')
                ret = [false, t('common:descEmpty')]

            // * if fdate is null 
            if (itr.fdate === '')
                ret[false, t('common:sSchemeEmpty')]
        })
        if (primarytDate.size > 1)
            ret = [false, t('common:activeScheme')]

        // console.log(ret)
        return (ret)
    }

    const removeFromChangesAfterSave = () => {
        setChanges([])
        setDeletedItems([])
    }

    // * Move to Submenu of selected line - Child Table in SQL one to many connection (i.e Branch/Loc - Salary Scheme/Components etc)
    const handlePress = async (item, index) => {
        if (Object.keys(changes).length > 0 || salarySchemeData.some(obj => areAllAttributesNullOrEmpty(obj, ['company', 'salarySchemeId']))) {
            let ret = await showSwall();
            if (!ret.isConfirmed) {
                return
            }
            else {
                handleCancelChanges(setSalarySchemeData, originalData, setDeletedItems, setChanges, setDuplicates)
            }

        }
        if (!props?.showSalaryScheme) {
            props?.setShowSalaryScheme(!props?.showSalaryScheme);
        }
        //* Setting the id column - Not consident in all tables must change
        setSelectedItem(item?.salarySchemeId);
        if (selectedItem === item?.salarySchemeId && props?.showSalaryScheme)
            return;
        setButtonStates((prevState) => {
            const newState = Object.keys(prevState).reduce((acc, key) => {
                acc[key] = false;
                return acc;
            }, {});
            newState[index] = !prevState[index];
            return newState;
        });
    }

    const showSwall = async () => {
        return Swal.fire({
            title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:changeBranchesMessage')}</text>`,
            icon: "warning",
            showCancelButton: true,
            reverseButtons: true,
            cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
            cancelButtonColor: '#d3d3d3',
            confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
            confirmButtonColor: '#A0A2FF',
        });
    }

    const handleGoBack = async () => {
        if (Object.keys(changesChildren).length > 0) {
            let ret = await showSwall();
            if (!ret.isConfirmed)
                return
        }
        if (props.showSalaryScheme) {
            props.setShowSalaryScheme(false);
            setButtonStates((prevState) => {
                const newState = Object.keys(prevState).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {});
                return newState;
            });
            setRefreshAfterSave(true);
        }
    }
    //#endregion

    //#region Components
    const renderSalarySchemes = useCallback(({ item, index }) => {
        if (props.showSalaryScheme)
            return renderPressableChildren(item, index);
        return (
            <Card
                style={[common.cardstyle]} >
                <Card.Content>
                    <SalarySchemeListView
                        item={item} index={index}
                        props={props}
                        colors={colors}
                        styles={styles}
                        handleEditPress={handleEditPress}
                        duplicates={duplicates}
                        handleDelete={handleDelete}
                        handlePress={handlePress}
                        showChildren={showChildren} />
                </Card.Content>
            </Card >
        )
    }, [salarySchemeData, duplicates, showChildren, selectedItem]);

    const renderPressableChildren = (item, index) => {
        if (hasUnsavedChanges)
            return (
                <View
                    style={styles.button}>
                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                // * Note: below styles do not seem to be working. Maybe investigate?
                                Swal.fire({
                                    title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:changeBranchesMessage')}</text>`,
                                    icon: "warning",
                                    showCancelButton: true,
                                    reverseButtons: true,
                                    cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
                                    cancelButtonColor: '#d3d3d3',
                                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
                                    confirmButtonColor: '#A0A2FF',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        setHasUnsavedChanges(false);
                                        handlePress(item, index);
                                    };
                                });
                            }
                        }}>
                        <View>
                            <Card
                                style={[common.cardstyle, buttonStates[index] === true ? [common.cardstyle, styles.Button_SELECTED] : null]} >
                                <Card.Content>
                                    <SalarySchemeListView
                                        item={item} index={index}
                                        props={props}
                                        styles={styles}
                                        handleEditPress={handleEditPress}
                                        duplicates={duplicates}
                                        handleDelete={handleDelete}
                                        handlePress={handlePress}
                                        showChildren={showChildren} />
                                </Card.Content>
                            </Card>
                        </View>
                    </TouchableOpacity>
                </View >
            )
        else return (
            <Pressable onPress={() => { handlePress(item, index) }}>
                <Card
                    style={[common.cardstyle, buttonStates[index] === true ? [common.cardstyle, styles.Button_SELECTED] : null]} >
                    <Card.Content>
                        <SalarySchemeListView
                            item={item} index={index}
                            props={props}
                            styles={styles}
                            handleEditPress={handleEditPress}
                            duplicates={duplicates}
                            handleDelete={handleDelete}
                            handlePress={handlePress}
                            showChildren={showChildren} />
                    </Card.Content>
                </Card>
            </Pressable>
        )
    };
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <SafeAreaView style={styles.mainView}>
            {props.showSalaryScheme &&
                <TouchableOpacity onPress={() => { handleGoBack() }} style={styles.backButton}>
                    <Ionicons name="arrow-back" size={30} color="black" />
                </TouchableOpacity>
            }
            <SafeAreaView style={styles.rowView}>
                <SafeAreaView style={[styles.subMain]}>
                    {props.selectedCompany &&
                        <View style={styles.innerView}>
                            {!props.showSalaryScheme &&
                                <View style={[styles.buttons, styles.functionalityButtons]}>
                                    <CustomButton
                                        text={t('common:new')}
                                        onPress={() => { rowAdd(salarySchemeData, setSalarySchemeData, ['company', 'salarySchemeId'], [], ref, t, [], [], changes, setChanges) }}
                                        type='BUTTON_ADD'
                                        textTop='0'
                                        sz={15}
                                    />
                                    {((Object.keys(changes).length > 0 && Object.values(changes)?.some(innerObj => !innerObj.hasOwnProperty('isNew'))) || salarySchemeData.length > 0) &&
                                        <CustomButton
                                            text={t('common:saveChanges')}
                                            onPress={() => { handleSave() }}
                                            type='BUTTON_SAVE'
                                            textTop='0'
                                            sz={15}
                                            isGradient={true}
                                        />
                                    }
                                    <CustomButton
                                        text={t('common:cancel')}
                                        onPress={() => { handleCancelChanges(setSalarySchemeData, originalData, setDeletedItems, setChanges, setDuplicates) }}
                                        type="BUTTON_CANCEL"
                                        textTop='0'
                                        sz={15}
                                    />
                                </View>
                            }
                            <View style={styles.branchesView}>
                                <FlatList
                                    style={props.showSalaryScheme ? styles.fullHeight : styles.fullWidth}
                                    data={salarySchemeData}
                                    keyExtractor={(item, index) => `${item?.salarySchemeId}-${index}`}
                                    renderItem={renderSalarySchemes}
                                    scrollEnabled={true}
                                    refreshing={isLoading}
                                    ref={ref}
                                    ListHeaderComponent={
                                        <SafeAreaView style={common.listTitle}>
                                            {props.showSalaryScheme ? <></> :
                                                <>
                                                    <View style={[styles.row, { marginRight: '7%', }]}>
                                                        <CustomLabel
                                                            value={t('common:salarySchemeDesc')}
                                                            type='SUBTITLE' />

                                                        <CustomLabel
                                                            value={t('common:schemeRange')}
                                                            type='SUBTITLE' />
                                                        <CustomLabel
                                                            value={t('common:companyCurrency')}
                                                            type='SUBTITLE' />
                                                    </View>
                                                    <SafeAreaView style={common.divider} />
                                                </>}
                                        </SafeAreaView>
                                    }
                                    initialNumToRender={10}
                                    ListEmptyComponent={
                                        isLoading ?
                                            <ActivityIndicator animating={true} color={colors.blue} />
                                            :
                                            <CustomLabel
                                                value={t("common:salarySchemeLoadingPreview")}
                                                type="NO_BRANCHES"
                                            />
                                    }
                                />
                                {props.showSalaryScheme ?
                                    <SafeAreaView style={styles.childView}>
                                        <HRAdminSalaryComponentsScreen
                                            props={{
                                                salarySchemeId: selectedItem,
                                                handleGoBack: handleGoBack,
                                                changes: changesChildren,
                                                setChanges: setChangesChildren,
                                            }}
                                        />
                                    </SafeAreaView>
                                    : <></>
                                }
                            </View>
                        </View>
                    }
                </SafeAreaView>
            </SafeAreaView >
        </SafeAreaView >
    )
};

const makeStyles = (colors, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        marginHorizontal: 10,
    },
    subMain: {
        borderRadius: 35,
        elevation: (Platform.OS === 'web' && width > 992 ? 3 : 0),
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        width: '100%'
    },
    rowView: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    cardstyleCompany: {
        margin: 10,
        borderRadius: 5,
        backgroundColor: colors.background_card,
    },
    cardStyleBranch: {
        margin: 10,
        borderRadius: 5,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },
    row: {
        flex: 1,
        flexDirection: "row",
        alignItems: 'center',
    },
    margin: {
        marginHorizontal: 10,
    },
    item: {
        flex: 1,
        justifyContent: 'center',
    },
    secondLine: {
        alignItems: 'center',
        margin: 5,
    },
    buttonSelected: {
        backgroundColor: colors.buttons,
        margin: 10,
        flexDirection: Platform.OS !== 'web' ? 'column' : 'row',
        borderRadius: 20,
        borderWidth: 2,
        borderColor: colors.buttons_submit,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
    },
    error: {
        color: colors.validation_error,
        alignSelf: 'center',
        fontSize: 14,
    },
    Button_SELECTED: {
        margin: 10,
        borderRadius: 5,
        borderWidth: 2,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
        borderColor: colors.buttons_submit,
    },
    icons: {
        fontSize: 25,
        margin: 10,
        color: colors.text_primary,
    },
    backButton: {
        alignSelf: 'flex-end'
    },
    innerView: {
        flex: 1,
    },
    branchesView: {
        flexDirection: 'row',
        height: '100%'
    },
    fullHeight: {
        height: '100%'
    },
    fullWidth: {
        height: '78%'
    },
    childView: {
        width: '85%',
        height: '100%'
    },
    functionalityButtons: {
        justifyContent: 'flex-end',
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginBottom: 10,
        alignSelf: 'flex-end',
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '4%'
    },
});


export default HRAdminSalarySchemeScreen;